/*
 * The fastpanel duck.
 *
 * I wasn't sure we were going to need this, but as it turns out, there are a few access patterns
 * within fastpanel that require the creation of a store; namely, that fastpanel must load and init
 * before you can ask it for the distinct_id ( makes sense ), but also that if we do override
 * the distinct_id with account_id, we are SOL in terms of getting the "super id" ( we cannot 'get' from
 * fastpanel unless it is within the load function, and that fires once ).
 *
 * Actions:
 * FASTPANEL_LOADED
 *
 * Action Creators:
 * fastpanelLoaded()
 *
 */

import type {
  FastpanelAction,
  FastpanelLoadedAction,
  FastpanelState,
} from '../types';

/** @type {ActionType} **/
/**
 * The fastpanel loaded action. Should basically fire once shortly after init.
 */

export const FASTPANEL_LOADED = 'PB/fastpanel/FASTPANEL_LOADED';

/** @ignore **/
export const initialState: FastpanelState = {
  superId: '',
  distinctId: '',
};

/** @ignore **/
export default function fastpanel(
  state: FastpanelState = initialState,
  action: FastpanelAction,
): FastpanelState {
  switch (action.type) {
    case FASTPANEL_LOADED:
      const { superId, distinctId } = action.payload;
      return { superId, distinctId };

    default:
      return state;
  }
}

/*
 * This action creator will return a FASTPANEL_LOADED action.
 *
 * @param {string} distinctId The distinct ID from fastpanel, this could be account id or fastpanel distinct.
 * @param {string} superId The super ID - we set this, it's always a  fastpanel id.
 *
 */
export function fastpanelLoaded(
  distinctId: string,
  superId: string,
): FastpanelLoadedAction {
  return {
    type: FASTPANEL_LOADED,
    payload: { distinctId, superId },
  };
}
